    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">
                        <el-form-item label="定制菜单:">
                            <el-select v-model="table.where.custom_menu_id" filterable placeholder="请选择">
                                <el-option v-for="item in custom_menu_list" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="用户:">
                            <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                                <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="支付状态:">
                            <el-select v-model="table.where.status" filterable placeholder="请选择">
                                <el-option label="未支付" value="0"></el-option>
                                <el-option label="定金" value="1"></el-option>
                                <el-option label="已支付" value="2"></el-option>
                                <el-option label="退款" value="3"></el-option>
                                <el-option label="取消订单" value="4"></el-option>
                                <el-option label="已完成结算" value="10"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="订单号:">
                            <el-input-number v-model="table.where.order_id" placeholder="请输入订单号" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>


                        <el-form-item label="发货状态:">
                            <el-select v-model="table.where.shipments_status" filterable placeholder="请选择">
                                <el-option label="未确认" value="1"></el-option>
                                <el-option label="未发货" value="2"></el-option>
                                <el-option label="发货中" value="3"></el-option>
                                <el-option label="申请退货" value="4"></el-option>
                                <el-option label="退货" value="5"></el-option>
                                <el-option label="完成" value="6"></el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item label="物流单号:">
                            <el-input v-model="table.where.dh" placeholder="请输入物流单号" clearable />
                        </el-form-item>

                        <el-form-item label="发货时间:">
                            <el-input-number v-model="table.where.consignment_time" placeholder="请输入发货时间"
                                :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>



                        <el-form-item label="数量:">
                            <el-input-number v-model="table.where.num" placeholder="请输入数量" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>


                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:customdeal:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>


                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:customdeal:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:customdeal:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                    <el-button :type="JSON.stringify(table.where) == '{}'?'warning':'info'" size="small"
                        @click="(table.where={})&&$refs.table.reload()">全部</el-button>
                    <el-button :type="table.where.status == 2?'warning':'info'" size="small"
                        @click="(table.where.status = 2)&&$refs.table.reload()">已完成结算</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                        <el-table-column prop="user_id" label="用户id" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.user_id_info"
                                    :key="index">{{item.nick_name+item.phone}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="order_id" label="订单号" sortable="custom" show-overflow-tooltip
                            min-width="250" />
                        <el-table-column prop="custom_menu_id" label="定制菜单" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.custom_menu_id_info"
                                    :key="index">{{item.name}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="num" label="数量" sortable="custom" show-overflow-tooltip
                            min-width="120" />


                        <el-table-column prop="out_refund_no" label="商户退款订单号" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="total_fee" label="金额" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="earnest" label="定金" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="balance_payment" label="尾款" sortable="custom" show-overflow-tooltip
                            min-width="120">
                            <template slot-scope="{row}">
                                <div>{{parseFloat(row.total_fee)-parseFloat(row.earnest)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="status" label="支付状态" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-if="row.status == 0" :key="index">未支付</el-tag>
                                <el-tag v-if="row.status == 1" :key="index">定金</el-tag>
                                <el-tag v-if="row.status == 2" :key="index">已支付</el-tag>
                                <el-tag v-if="row.status == 3" :key="index">退款</el-tag>
                                <el-tag v-if="row.status == 4" :key="index">取消订单</el-tag>
                            </template>
                        </el-table-column>



                        <el-table-column prop="shipments_status" label="发货状态" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-if="row.shipments_status == 1" :key="index">未确认</el-tag>
                                <el-tag v-if="row.shipments_status == 2" :key="index">未发货</el-tag>
                                <el-tag v-if="row.shipments_status == 3" :key="index">发货中</el-tag>
                                <el-tag v-if="row.shipments_status == 4" :key="index">申请退货</el-tag>
                                <el-tag v-if="row.shipments_status == 5" :key="index">退货</el-tag>
                                <el-tag v-if="row.shipments_status == 6" :key="index">完成</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="delivery_address_id" label="发货地址ID" show-overflow-tooltip
                            min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.delivery_address_id_info"
                                    :key="index">{{item.name}}</el-tag>
                            </template>
                        </el-table-column>


                        <el-table-column prop="dh" label="物流单号" sortable="custom" show-overflow-tooltip
                            min-width="120" />



                        <el-table-column prop="consignment_time" label="发货时间" sortable="custom" show-overflow-tooltip
                            min-width="120" />




                        <el-table-column prop="delivery_address_id_info.name" label="姓名" sortable="custom"
                            show-overflow-tooltip min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.delivery_address_id_info" :key="index">
                                    {{ item.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="custom_menu_id_info.name" label="名称" sortable="custom"
                            show-overflow-tooltip min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.custom_menu_id_info" :key="index">
                                    {{ item.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="user_id_info.nick_name" label="用户昵称" sortable="custom"
                            show-overflow-tooltip min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.user_id_info" :key="index">
                                    {{ item.nick_name }}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:storegoodsorder:edit')">详细信息</el-link>
                                <!-- <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:customdeal:edit')">修改</el-link> -->
                                <el-popconfirm title="确定要删除此定制订单管理吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:customdeal:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <!-- <el-dialog :title="editForm.id?'修改定制订单管理':'添加定制订单管理'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">


                    <el-form-item label="用户id:" prop="user_id">
                        <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                :value="item.id">
                            </el-option>
                        </el-select>

                    </el-form-item>





                    <el-form-item label="商户退款订单号:" prop="out_refund_no">
                        <el-input v-model="editForm.out_refund_no" placeholder="请输入商户退款订单号" clearable />
                    </el-form-item>

                    <el-form-item label="金额:" prop="total_fee">
                        <el-input-number v-model="editForm.total_fee" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入金额" clearable />
                    </el-form-item>

                    <el-form-item label="定金:" prop="earnest">
                        <el-input-number v-model="editForm.earnest" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入定金" clearable />
                    </el-form-item>

                    <el-form-item label="尾款:" prop="balance_payment">
                        <el-input-number v-model="editForm.balance_payment" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入尾款" clearable />
                    </el-form-item>

                    <el-form-item label="积分:" prop="coin">
                        <el-input-number v-model="editForm.coin" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入积分" clearable />
                    </el-form-item>


                    <el-form-item label="评价状态:" prop="estimate_status">
                        <el-switch v-model="editForm.estimate_status" active-text="是" inactive-text="否"
                            :active-value="1" :inactive-value="0" />

                    </el-form-item>

                    <el-form-item label="支付状态:" prop="status">
                        <el-select v-model="editForm.status" filterable placeholder="请选择支付状态">
                            <el-option label="未支付" value="0"></el-option>
                            <el-option label="定金" value="1"></el-option>
                            <el-option label="已支付" value="2"></el-option>
                            <el-option label="退款" value="3"></el-option>
                            <el-option label="取消订单" value="4"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="排序:" prop="sort">
                        <el-input-number v-model="editForm.sort" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                    </el-form-item>



                    <el-form-item label="备注:" prop="remake">
                        <el-input type="textarea" v-model="editForm.remake" placeholder="请输入备注" clearable />
                    </el-form-item>

                    <el-form-item label="发货状态:" prop="shipments_status">
                        <el-select v-model="editForm.shipments_status" filterable placeholder="请选择发货状态">
                            <el-option label="未确认" value="1"></el-option>
                            <el-option label="未发货" value="2"></el-option>
                            <el-option label="发货中" value="3"></el-option>
                            <el-option label="申请退货" value="4"></el-option>
                            <el-option label="退货" value="5"></el-option>
                            <el-option label="完成" value="6"></el-option>
                        </el-select>
                    </el-form-item>



                    <el-form-item label="发货地址ID:" prop="delivery_address_id">
                        <el-select v-model="editForm.delivery_address_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_address_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="物流单号:" prop="dh">
                        <el-input v-model="editForm.dh" placeholder="请输入物流单号" clearable />
                    </el-form-item>

                    <el-form-item label="退货物流单号:" prop="PMTQFt_custom_dh">
                        <el-input v-model="editForm.PMTQFt_custom_dh" placeholder="请输入退货物流单号" clearable />
                    </el-form-item>

                    <el-form-item label="发货时间:" prop="consignment_time">
                        <el-input-number v-model="editForm.consignment_time" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入发货时间" clearable />
                    </el-form-item>

                    <el-form-item label="消费类型 1=成品商品(品鉴普通) 2=定制商品 3=封坛商品 4=积分商品:" prop="type">
                        <el-input-number v-model="editForm.type" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left"
                            placeholder="请输入消费类型 1=成品商品(品鉴普通) 2=定制商品 3=封坛商品 4=积分商品" clearable />
                    </el-form-item>



                    <el-form-item label="数量:" prop="num">
                        <el-input-number v-model="editForm.num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入数量" clearable />
                    </el-form-item>


                    <el-form-item label="定制菜单id:" prop="custom_menu_id">
                        <el-select v-model="editForm.custom_menu_id" filterable placeholder="请选择">
                            <el-option v-for="item in custom_menu_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog> -->


            <el-dialog title="详情信息" :visible.sync="showEdit" width="800px" :destroy-on-close="true" :lock-scroll="false"
                @close="closeDialog" :close-on-click-modal="false">
                <el-form :inline="true" ref="form" :model="editForm" label-width="80px">


                    <el-form-item label="合成图:">
                        <el-image style="width: 150px; height: 150px" :src="editForm.specimen_image"
                            :preview-src-list="[editForm.specimen_image]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="logo图:">
                        <el-image style="width: 150px; height: 150px" :src="editForm.logo_image"
                            :preview-src-list="[editForm.logo_image]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="正面图:">
                        <el-image style="width: 150px; height: 150px" :src="editForm.front_view"
                            :preview-src-list="[editForm.front_view]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="背面图:">
                        <el-image style="width: 150px; height: 150px" :src="editForm.rear_view"
                            :preview-src-list="[editForm.rear_view]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="盒子图:">
                        <el-image v-if="editForm.custom_box_info" style="width: 150px; height: 150px"
                            :src="editForm.custom_box_info.thumbnail"
                            :preview-src-list="[editForm.custom_box_info.thumbnail]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="定制菜单:">
                        <el-tag v-if="editForm.custom_menu_info">{{editForm.custom_menu_info.name}}</el-tag>
                        <!-- <div style="color: #353535;"></div> -->
                    </el-form-item>
                    <el-form-item label="字体:">
                        <el-tag v-if="editForm.font_info">{{editForm.font_info.name}}</el-tag>
                    </el-form-item>

                    <el-form-item label="酒体名称:">
                        <el-tag v-if="editForm.custom_bottled_info">{{editForm.custom_bottled_info.name}}</el-tag>
                    </el-form-item>
                    <el-form-item label="酒体价格:">
                        <el-tag v-if="editForm.custom_bottled_info">{{editForm.custom_bottled_info.price}}</el-tag>
                    </el-form-item>

                </el-form>
                <div slot="footer">
                    <el-button type="primary" @click="closeDialog">确认</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";


        export default {
            name: "SysCustomDeal",
            components: {},
            data() {
                return {
                    table: {
                        url: '/custom/CustomDeal/index',
                        where: {}
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {}, // 表单数据
                    editFormTemp: {},
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    user_address_list: [],
                    custom_menu_list: [],
                    user_openinfo_list: [],
                    editRules: { // 表单验证规则

                        user_id: [{
                            required: true,
                            message: '请选择用户id',
                            trigger: 'blur'
                        }],


                        order_id: [{
                            required: true,
                            message: '请选择商户/定金订单号',
                            trigger: 'blur'
                        }],


                        balance_payment_order_id: [{
                            required: true,
                            message: '请选择尾款订单号',
                            trigger: 'blur'
                        }],


                        out_refund_no: [{
                            required: true,
                            message: '请输入商户退款订单号',
                            trigger: 'blur'
                        }],


                        total_fee: [{
                            required: true,
                            message: '请输入金额',
                            trigger: 'blur'
                        }],


                        earnest: [{
                            required: true,
                            message: '请输入定金',
                            trigger: 'blur'
                        }],


                        balance_payment: [{
                            required: true,
                            message: '请输入尾款',
                            trigger: 'blur'
                        }],


                        coin: [{
                            required: true,
                            message: '请输入积分',
                            trigger: 'blur'
                        }],



                        status: [{
                            required: true,
                            message: '请选择支付状态',
                            trigger: 'blur'
                        }],



                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                        remake: [{
                            required: true,
                            message: '请输入备注',
                            trigger: 'blur'
                        }],


                        shipments_status: [{
                            required: true,
                            message: '请选择发货状态',
                            trigger: 'blur'
                        }],


                        delivery_address_id: [{
                            required: true,
                            message: '请选择发货地址ID',
                            trigger: 'blur'
                        }],


                        dh: [{
                            required: true,
                            message: '请输入物流单号',
                            trigger: 'blur'
                        }],


                        PMTQFt_custom_dh: [{
                            required: true,
                            message: '请输入退货物流单号',
                            trigger: 'blur'
                        }],


                        consignment_time: [{
                            required: true,
                            message: '请输入发货时间',
                            trigger: 'blur'
                        }],


                        type: [{
                            required: true,
                            message: '请输入消费类型 1=成品商品(品鉴普通) 2=定制商品 3=封坛商品 4=积分商品',
                            trigger: 'blur'
                        }],


                        conversion_id: [{
                            required: true,
                            message: '请选择积分商品ID',
                            trigger: 'blur'
                        }],


                        num: [{
                            required: true,
                            message: '请输入数量',
                            trigger: 'blur'
                        }],


                        custom_menu_id: [{
                            required: true,
                            message: '请选择定制菜单id',
                            trigger: 'blur'
                        }],



                        name: [{
                            required: true,
                            message: '请输入名称',
                            trigger: 'blur'
                        }],


                        nick_name: [{
                            required: true,
                            message: '请输入用户昵称',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {

                this.userAllList();
                this.UserAddressAllList();
                this.CustomMenuAllList();
                this.UserOpeninfoAllList();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/custom/CustomDealGoods/info?order_id=' + row.order_id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 显示编辑
                 */
                edit1(row) {
                    this.$http.get('/custom/CustomDeal/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/custom/CustomDeal/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的定制订单管理吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/custom/CustomDeal/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/custom/CustomDeal/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 获取全部会员 */
                userAllList() {
                    this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/custom/CustomDeal/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                UserAddressAllList() {
                    this.$http.post('/user/UserAddress/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_address_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                //查询其他信息
                CustomMenuAllList() {
                    this.$http.post('/custom/CustomMenu/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.custom_menu_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                //查询其他信息
                UserOpeninfoAllList() {
                    this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_openinfo_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },

                /**
         * 更改状态

         */
                editStatus(row, name) {
                    const loading = this.$loading({
                        lock: true
                    });
                    let data = {
                        id: row.id,
                        name: name,
                        value: row[name],
                    }
                    this.$http.post("/custom/CustomDeal/status", data).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                        } else {
                            row[name] = !row[name] ? 1 : 0;
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                },
            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>